var _defs, _path, _text, _text2, _g, _text3, _text4, _rect, _g2, _g3, _rect2, _text5, _g4, _g5, _g6, _rect3, _text6, _text7, _rect4, _rect5, _g7, _g8, _g9, _g10, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 717,
    height: 669,
    viewBox: "0 47 717 669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46294",
    "data-name": "Path 46294",
    d: "M30.946,0A30.946,30.946,0,1,1,0,30.946,30.946,30.946,0,0,1,30.946,0Z",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_08_20_-_Present"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47007",
    "data-name": "Group 47007",
    transform: "translate(-999 -3743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46801",
    "data-name": "Group 46801",
    transform: "translate(825 3781)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 86, -38)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46298-2",
    "data-name": "Path 46298",
    d: "M30,0H402c16.569,0,30,13.971,30,31.206V363.03c0,17.235-13.431,31.206-30,31.206H30c-16.569,0-30-13.971-30-31.206V31.206C0,13.971,13.431,0,30,0Z",
    transform: "translate(119 170)",
    fill: "#212121"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Alexis_Williams",
    "data-name": "Alexis Williams",
    transform: "translate(322.556 191.054)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alexis Williams"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_CA",
    "data-name": "Los Angeles, CA",
    transform: "translate(322.556 218.054)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, CA"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(241.737 167.107)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46273",
    "data-name": "Path 46273",
    d: "M.062,30.946A30.946,30.946,0,1,1,31.008,61.893,30.947,30.947,0,0,1,.062,30.946",
    transform: "translate(-0.062 0)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46274",
    "data-name": "Path 46274",
    d: "M14.234,68.07S9.369,58.232,16.416,52.8c4.3-3.315,5.684-7.137,4.855-10.457s.143-12.164,3.058-15.377S42.236,21.1,46.54,29.149s1.943,13.7,4.3,18.343,6.355,5.93,5.746,14.83-8.3,14.866-9.548,14.7-21.462-2.148-22.989-2.977-9.817-5.975-9.817-5.975",
    transform: "translate(-3.881 -7.261)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46275",
    "data-name": "Path 46275",
    d: "M29.418,34.559a12.134,12.134,0,0,1-.433-7.994,5.012,5.012,0,0,1,2.484-2.928,2.714,2.714,0,0,1,.907-.285s-1.2-2.261,3.283-4.258,11.658-.966,14.725,5.026-.435,13.83-1.568,15.013-17.1.465-19.4-4.574",
    transform: "translate(-8.719 -5.534)",
    fill: "#000102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46276",
    "data-name": "Path 46276",
    d: "M56.927,91.654H12.672s1.387-11.633,2.49-16.549a14.354,14.354,0,0,1,.413-1.544c1.131-3.23,13.412-4.2,14.542-5.813h9.363c1.131,1.615,13.412,2.583,14.543,5.813a16.2,16.2,0,0,1,.5,1.921c1.088,5.109,2.4,16.172,2.4,16.172",
    transform: "translate(-3.904 -20.64)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46277",
    "data-name": "Path 46277",
    d: "M47.677,64.856l-5.664,2.822-5.664-2.822a11.41,11.41,0,0,0,1.335-3.662,20.588,20.588,0,0,0,.452-4.943h7.754a20.824,20.824,0,0,0,.237,3.758,12.488,12.488,0,0,0,1.551,4.846",
    transform: "translate(-11.117 -17.138)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46278",
    "data-name": "Path 46278",
    d: "M46.711,60.01c-2.746,1.464-6.666,1.336-8.443,1.185a20.6,20.6,0,0,0,.452-4.943h7.754a20.825,20.825,0,0,0,.237,3.758",
    transform: "translate(-11.702 -17.138)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46279",
    "data-name": "Path 46279",
    d: "M31.2,43.573s-.909-3.595-3.169-2,0,6.847,3.185,6.819c0,0,.85-3.524-.016-4.817",
    transform: "translate(-8.304 -12.541)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46280",
    "data-name": "Path 46280",
    d: "M29.466,44.159a2.908,2.908,0,0,1,1.154.957,3.512,3.512,0,0,1,.784,1.27c.038.145-.166.209-.25.111-.238-.278-.418-.6-.636-.894a1.644,1.644,0,0,1-.656.407c-.2.048-.31-.2-.209-.348a1.492,1.492,0,0,1,.551-.419,7.585,7.585,0,0,1-.906-.855.148.148,0,0,1,.169-.227",
    transform: "translate(-8.959 -13.451)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46281",
    "data-name": "Path 46281",
    d: "M56.087,43.573s.909-3.595,3.169-2,0,6.847-3.185,6.819c0,0-.85-3.524.016-4.817",
    transform: "translate(-17.012 -12.541)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46282",
    "data-name": "Path 46282",
    d: "M58.842,44.159a2.913,2.913,0,0,0-1.154.957,3.512,3.512,0,0,0-.784,1.27c-.038.145.166.209.25.111.238-.278.418-.6.636-.894a1.644,1.644,0,0,0,.656.407c.2.048.311-.2.21-.348a1.5,1.5,0,0,0-.551-.419,7.586,7.586,0,0,0,.906-.855.147.147,0,0,0-.169-.227",
    transform: "translate(-17.378 -13.451)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46283",
    "data-name": "Path 46283",
    d: "M49.278,34.022c-1.881-9.022-8.8-8.389-8.8-8.389s-6.919-.633-8.8,8.389a17.293,17.293,0,0,0,.8,10.04c1.22,3,3.563,6.228,8,6.228s6.776-3.23,8-6.228a17.293,17.293,0,0,0,.8-10.04",
    transform: "translate(-9.574 -7.806)",
    fill: "#f5a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46284",
    "data-name": "Path 46284",
    d: "M38.236,42.288s-.768.286-.652-1.074c.1-1.222.652-1.058.652-1.058s.534,0,.453,1.066-.453,1.066-.453,1.066",
    transform: "translate(-11.49 -12.231)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46285",
    "data-name": "Path 46285",
    d: "M49.508,42.288s-.768.286-.652-1.074c.1-1.222.652-1.058.652-1.058s.534,0,.453,1.066-.453,1.066-.453,1.066",
    transform: "translate(-14.924 -12.231)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46286",
    "data-name": "Path 46286",
    d: "M45.232,51.939a8.67,8.67,0,0,1-1.916.624c-.646.038-1.213-.286-1.824-.276a.1.1,0,0,0-.083.145c.705,1.094,3.362.755,3.979-.289a.14.14,0,0,0-.156-.2",
    transform: "translate(-12.654 -15.822)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46287",
    "data-name": "Path 46287",
    d: "M39.054,37.125a2.022,2.022,0,0,0-1.32-.3c-.411.006-1,.008-1.275.352a.074.074,0,0,0,.033.122,3.5,3.5,0,0,0,1.154-.047,12.078,12.078,0,0,0,1.314.1c.1-.013.2-.147.1-.23",
    transform: "translate(-11.145 -11.219)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46288",
    "data-name": "Path 46288",
    d: "M50.569,36.82a1.129,1.129,0,0,0-1.156-.46c-.419.037-1.053.156-1.273.553a.108.108,0,0,0,.065.158c.335.092.627-.109.955-.176a2.575,2.575,0,0,1,1.236.151.156.156,0,0,0,.174-.226",
    transform: "translate(-14.705 -11.074)",
    fill: "#3b2645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46289",
    "data-name": "Path 46289",
    d: "M43.43,45.885c-.344-.073-1.161-.063-1.293-.33a10.342,10.342,0,0,1,.6-1.918,7.813,7.813,0,0,0,.232-3.258.062.062,0,0,0-.119,0c-.212.906-.22,1.845-.413,2.758s-.527,1.791-.807,2.69a.171.171,0,0,0,.163.213,4.469,4.469,0,0,0,1.642.022.093.093,0,0,0,0-.178",
    transform: "translate(-12.722 -12.288)",
    fill: "#e0855c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46290",
    "data-name": "Path 46290",
    d: "M37.138,26.629a24.294,24.294,0,0,0,10.779,1.959s3.162,4.342,3.507,7.494a9.213,9.213,0,0,0-.546-8.591c-2.656-4.756-12.552-6.147-13.74-.862",
    transform: "translate(-11.357 -7.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46291",
    "data-name": "Path 46291",
    d: "M56.927,94.877H12.672s.1-.861.277-2.22q.043-.31.086-.662c.014-.1.021-.192.035-.3.029-.22.057-.455.092-.7.121-.9.256-1.907.391-2.952l.107-.7c.015-.114.029-.22.042-.334.043-.284.079-.562.121-.847.136-.925.277-1.864.42-2.767.05-.341.107-.676.164-1.01.035-.249.078-.484.113-.719.213-1.266.434-2.418.64-3.336,5.593,1.843,16.692,2.169,39.361.377.149.711.306,1.53.462,2.426.064.348.121.711.185,1.081.007.064.021.129.029.193.064.384.128.782.192,1.181.107.676.207,1.366.306,2.064.071.448.135.9.2,1.345.008.035.008.064.015.1.057.405.114.8.163,1.2.114.782.213,1.537.306,2.234.043.355.092.7.129,1.031.021.129.035.257.049.378.042.313.079.6.114.875l.256,2.071",
    transform: "translate(-3.904 -23.863)",
    fill: "#0f59da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46292",
    "data-name": "Path 46292",
    d: "M30.561,49.534a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5",
    transform: "translate(-9.354 -14.938)",
    fill: "#308dbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46293",
    "data-name": "Path 46293",
    d: "M57,49.534a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5",
    transform: "translate(-17.41 -14.938)",
    fill: "#308dbd"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Work_Experience",
    "data-name": "Work Experience",
    transform: "translate(241.737 273)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Work Experience"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "Skills",
    transform: "translate(241.737 392)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Skills"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17693",
    "data-name": "Rectangle 17693",
    width: 359,
    height: 72,
    transform: "translate(242 288)",
    fill: "#363636"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Web_Developer_at_TechWave_Solutions-2",
    "data-name": "Web Developer at TechWave Solutions",
    transform: "translate(257 316)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Developer at TechWave Solutions")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 86, -38)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Web_Developer_at_TechWave_Solutions-3",
    "data-name": "Web Developer at TechWave Solutions",
    transform: "translate(171 354)",
    fill: "rgba(0, 0, 0, 0.161)",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Developer at TechWave Solutions"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_08_20_-_Present-2",
    "data-name": "08/20 - Present",
    transform: "translate(257 338)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/20 - Present")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 86, -38)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_08_20_-_Present-3",
    "data-name": "08/20 - Present",
    transform: "translate(171 376)",
    fill: "rgba(0, 0, 0, 0.161)",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/20 - Present"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46784",
    "data-name": "Group 46784",
    transform: "translate(31 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46781",
    "data-name": "Group 46781",
    transform: "translate(-3 232)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546-3",
    "data-name": "Rectangle 17546",
    width: 296,
    height: 346,
    rx: 30,
    transform: "translate(548.5 59)",
    fill: "#212121"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "Pathways",
    transform: "translate(598 99)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pathways"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "route",
    transform: "translate(576.433 84.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38406",
    "data-name": "Path 38406",
    d: "M12.031,15.7H8.379c-1.315,0-3.8-.665-3.8-3.185s2.484-3.185,3.8-3.185h3.244c.11,0,2.7-.037,2.7-2.089s-2.593-2.089-2.7-2.089H7.97a.548.548,0,0,1,0-1.1h3.653c1.315,0,3.8.665,3.8,3.185s-2.484,3.185-3.8,3.185H8.379c-.11,0-2.7.037-2.7,2.089s2.593,2.089,2.7,2.089h3.653a.548.548,0,0,1,0,1.1Z",
    transform: "translate(-3.382 -2.007)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38407",
    "data-name": "Path 38407",
    d: "M5.5,6.408a2.579,2.579,0,1,1,.994-.19,2.579,2.579,0,0,1-.994.19Zm0-4.062a1.461,1.461,0,1,0,.559.111A1.461,1.461,0,0,0,5.5,2.346Z",
    transform: "translate(-2.94 -1.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38408",
    "data-name": "Path 38408",
    d: "M16.606,20.848a2.579,2.579,0,1,1,1.819-.758,2.579,2.579,0,0,1-1.819.758Zm0-4.062a1.461,1.461,0,1,0,1.033.428,1.461,1.461,0,0,0-1.033-.428Z",
    transform: "translate(-5.926 -5.141)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46783",
    "data-name": "Group 46783",
    transform: "translate(-441.893 -572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22337",
    className: "web-dev-arrow",
    "data-name": "Group 22337",
    transform: "translate(1132.643 971.109)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_656",
    "data-name": "Line 656",
    y2: 19.988,
    transform: "translate(4.109 22.855)",
    fill: "none",
    stroke: "#469dcc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M3.5,0,7,8H0Z",
    transform: "translate(7.357 46.355) rotate(180)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path-web-dev"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14054",
    "data-name": "Rectangle 14054",
    width: 241.786,
    height: 67,
    transform: "translate(1015 927)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Web_Developer",
    "data-name": "Web Developer",
    transform: "translate(1025 952)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 57.049,
    y: 12
  }, "Web Developer"))), /*#__PURE__*/React.createElement("g", {
    className: "path-senior-dev"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14050",
    "data-name": "Rectangle 14050",
    width: 241.786,
    height: 67,
    transform: "translate(1015 1019)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Senior_Web_Developer",
    "data-name": "Senior Web Developer",
    transform: "translate(1056 1043)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1,
    y: 12
  }, "Senior Web Developer"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22338",
    className: "web-senior-arrow",
    "data-name": "Group 22338",
    transform: "translate(1132.643 1063.609)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_656-2",
    "data-name": "Line 656",
    y2: 19.988,
    transform: "translate(4.109 22.855)",
    fill: "none",
    stroke: "#7a849c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M3.5,0,7,8H0Z",
    transform: "translate(7.357 46.355) rotate(180)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path-full-dev"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46295",
    "data-name": "Path 46295",
    d: "M0,0H241.786V67H0Z",
    transform: "translate(1015 1109)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Full-Stack_Developer",
    "data-name": "Full-Stack Developer",
    transform: "translate(1029 1134)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.191,
    y: 12
  }, "Full-Stack Developer")))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46800",
    "data-name": "Group 46800",
    transform: "translate(0 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46794",
    "data-name": "Group 46794",
    transform: "translate(238 420.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Frameworks",
    "data-name": "Front-End Frameworks",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Frameworks"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46795",
    "data-name": "Group 46795",
    transform: "translate(371 420.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-2",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 112,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Responsive_Design",
    "data-name": "Responsive Design",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Responsive Design"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46796",
    "data-name": "Group 46796",
    transform: "translate(350 449.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-3",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 137,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_Database_Management",
    "data-name": " Database Management",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "Database Management"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46797",
    "data-name": "Group 46797",
    transform: "translate(238 449.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-4",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 106,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Security_Practices",
    "data-name": "Security Practices",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Security Practices"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46798",
    "data-name": "Group 46798",
    transform: "translate(238 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-5",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SEO_Basics",
    "data-name": "SEO Basics",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEO Basics"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46799",
    "data-name": "Group 46799",
    transform: "translate(316 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15104-6",
    "data-name": "Rectangle 15104",
    transform: "translate(4 1)",
    fill: "#363636",
    stroke: "rgba(61,182,251,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 24,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 107,
    height: 23,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Strategic_Thinking",
    "data-name": "Strategic Thinking",
    transform: "translate(14 16)",
    fill: "#3db6fb",
    fontSize: 10,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Strategic Thinking"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46785",
    "data-name": "Group 46785",
    transform: "translate(-716 -1452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 802, 1414)",
    stroke: "rgba(0, 0, 0, 0.518)",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    style: {
      filter: "drop-shadow(-20px 0px 33px rgba(0, 0, 0, 0.518))"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17546-4",
    "data-name": "Rectangle 17546",
    width: 340,
    height: 204,
    rx: 30,
    transform: "translate(428 471)",
    fill: "#212121"
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "Front-End_Web_Developer",
    "data-name": "Front-End Web Developer",
    transform: "translate(1318.556 1967.5)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front-End Web Developer"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "Mobile_Web_Developer",
    "data-name": "Mobile Web Developer",
    transform: "translate(1318.556 2030.5)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mobile Web Developer"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17695",
    "data-name": "Rectangle 17695",
    width: 45,
    height: 45,
    rx: 12,
    transform: "translate(1257 1951)",
    fill: "#353535"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17696",
    "data-name": "Rectangle 17696",
    width: 45,
    height: 45,
    rx: 12,
    transform: "translate(1257 2014)",
    fill: "#353535"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-code",
    "data-name": "Icon ionic-ios-code",
    transform: "translate(1261.496 1955.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46296",
    "data-name": "Path 46296",
    d: "M23.344,10.034a.436.436,0,0,0-.288-.12.423.423,0,0,0-.288.12l-.97.928a.409.409,0,0,0,0,.6L28.533,18,21.8,24.434a.409.409,0,0,0,0,.6l.97.928a.423.423,0,0,0,.288.12.41.41,0,0,0,.288-.12l8.03-7.664a.409.409,0,0,0,0-.6Z",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46297",
    "data-name": "Path 46297",
    d: "M14.344,11.264a.416.416,0,0,0-.134-.3l-.97-.928a.436.436,0,0,0-.288-.12.423.423,0,0,0-.288.12L4.634,17.7a.409.409,0,0,0,0,.6l8.03,7.664a.436.436,0,0,0,.288.12.41.41,0,0,0,.288-.12l.97-.928a.409.409,0,0,0,0-.6L7.474,18l6.736-6.434A.416.416,0,0,0,14.344,11.264Z",
    fill: "#3db6fb"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-code-2",
    "data-name": "Icon ionic-ios-code",
    transform: "translate(1261.496 2018.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46296-2",
    "data-name": "Path 46296",
    d: "M23.344,10.034a.436.436,0,0,0-.288-.12.423.423,0,0,0-.288.12l-.97.928a.409.409,0,0,0,0,.6L28.533,18,21.8,24.434a.409.409,0,0,0,0,.6l.97.928a.423.423,0,0,0,.288.12.41.41,0,0,0,.288-.12l8.03-7.664a.409.409,0,0,0,0-.6Z",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46297-2",
    "data-name": "Path 46297",
    d: "M14.344,11.264a.416.416,0,0,0-.134-.3l-.97-.928a.436.436,0,0,0-.288-.12.423.423,0,0,0-.288.12L4.634,17.7a.409.409,0,0,0,0,.6l8.03,7.664a.436.436,0,0,0,.288.12.41.41,0,0,0,.288-.12l.97-.928a.409.409,0,0,0,0-.6L7.474,18l6.736-6.434A.416.416,0,0,0,14.344,11.264Z",
    fill: "#3db6fb"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_California-3",
    "data-name": "Los Angeles, California",
    transform: "translate(1319 1989.5)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, California")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 802, 1414)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_California-4",
    "data-name": "Los Angeles, California",
    transform: "translate(517 575.5)",
    fill: "rgba(0, 0, 0, 0.161)",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, California"))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_California-5",
    "data-name": "Los Angeles, California",
    transform: "translate(1319 2052.5)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, California")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 802, 1414)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Los_Angeles_California-6",
    "data-name": "Los Angeles, California",
    transform: "translate(517 638.5)",
    fill: "rgba(0, 0, 0, 0.161)",
    fontSize: 13,
    fontFamily: "Helvetica",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Los Angeles, California"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "Recommendations",
    transform: "translate(1260 1922)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recommendations")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeExperience);
export default __webpack_public_path__ + "static/media/employeeExperience.aaf852b486a4b701731b320cbc42d9ce.svg";
export { ForwardRef as ReactComponent };